/**
 * CMS 導覽設定 — Sidebar 與 TopBar 共用的單一來源。
 *
 * 導覽項目僅列實際存在的路由（見 routes.tsx）；新增頁面時於此同步登錄。
 */

export type NavGroup = 'core' | 'm1' | 'm2' | 'display' | 'd2' | 'sys';

export interface NavItem {
  to: string;
  label: string;
  /** emoji icon — 設計系統正式化前的輕量佔位 */
  icon: string;
  group: NavGroup;
}

export const NAV: NavItem[] = [
  { to: '/', label: 'Dashboard', icon: '📊', group: 'core' },
  { to: '/reports', label: '票務統計報表', icon: '📈', group: 'core' },
  { to: '/refund-policies', label: '退票政策（B-2 / AC-B2-1）', icon: '💵', group: 'm1' },
  { to: '/refunds', label: '退款總覽', icon: '💰', group: 'm1' },
  {
    to: '/refunds/manual-reviews',
    label: 'Manual Review（退票人工複核）',
    icon: '🔍',
    group: 'm1',
  },
  { to: '/admin/orders', label: '訂單管理', icon: '🧾', group: 'm1' },
  { to: '/notifications/dlq', label: '通知 DLQ（H-6 / H-8）', icon: '🔔', group: 'm1' },
  { to: '/products', label: '商品管理（A-1）', icon: '📦', group: 'm2' },
  { to: '/schedules', label: '班次管理（A-2）', icon: '📅', group: 'm2' },
  { to: '/pricing', label: '定價推廣（A-3）', icon: '🏷️', group: 'm2' },
  { to: '/spots', label: '景點管理（F-3）', icon: '📍', group: 'm2' },
  { to: '/recommendation-weights', label: '行程推薦加權（C-1）', icon: '🎯', group: 'm2' },
  { to: '/media', label: '媒體庫', icon: '🗂️', group: 'm2' },
  { to: '/display-publish', label: '窗屏內容發布', icon: '🚢', group: 'display' },
  { to: '/release-manifests', label: 'Release Manifest 看板（F-2）', icon: '📤', group: 'display' },
  { to: '/display-config-files', label: '船機設定檔（config/）', icon: '⚙️', group: 'display' },
  { to: '/display-global-media', label: '全域影片（assets/video/）', icon: '🎬', group: 'display' },
  { to: '/display-update-simulation', label: '船機更新模擬', icon: '🛰️', group: 'display' },
  { to: '/display-telemetry', label: '導覽播放統計', icon: '🎧', group: 'display' },
  { to: '/device-quarantines', label: '裝置隔離看板（D-2）', icon: '🖥️', group: 'd2' },
  {
    to: '/leases/forced-reclaim',
    label: '強制收回 lease（D-2 / AC-D2-14）',
    icon: '🔒',
    group: 'd2',
  },
  { to: '/streams/dlq', label: '戰情同步異常（I-6）', icon: '📡', group: 'd2' },
  { to: '/admin/partners', label: '夥伴管理（G）', icon: '🤝', group: 'sys' },
  { to: '/admin/devices', label: '設備儀表板（H-3）', icon: '🖥️', group: 'sys' },
  { to: '/admin/users', label: '使用者管理', icon: '👥', group: 'sys' },
  { to: '/admin/roles', label: '角色管理', icon: '🛡️', group: 'sys' },
  { to: '/admin/permissions', label: '權限目錄', icon: '🔑', group: 'sys' },
  { to: '/admin/ai-settings', label: 'AI 設定', icon: '🤖', group: 'sys' },
];

export const GROUP_ORDER: NavGroup[] = ['core', 'm1', 'm2', 'display', 'd2', 'sys'];

export const GROUP_LABEL: Record<NavGroup, string> = {
  core: '主控台',
  m1: 'M1 訂退',
  m2: 'M2 內容',
  display: '窗屏管理',
  d2: 'M2 離線檢票 / 發布',
  sys: '系統管理',
};

/**
 * 依 pathname 找最佳匹配的 NAV item（最長前綴）— 供 active 標記與
 * TopBar 標題使用。子路由（如 /products/new）會匹配到 /products。
 */
export function matchNav(pathname: string): NavItem | undefined {
  let best: NavItem | undefined;
  for (const item of NAV) {
    const hit = item.to === '/' ? pathname === '/' : pathname.startsWith(item.to);
    if (hit && (!best || item.to.length > best.to.length)) best = item;
  }
  return best;
}
